import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import * as luxon from 'luxon';

bootstrapApplication(AppComponent, appConfig).then(()=>{
  luxon.Settings.defaultLocale=navigator.language;
  }
)
  .catch((err) => console.error(err));
